import styled from "styled-components";

export const StyledPastExperiences = styled.div`
  height: 100%;
`;
